import React, { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';

import { Button } from '@mui/material';

import './LoanTermInfoSection.css';

export const LoanTermInfoSection = ({
  aprRate,
  len = 1,
  monthlyPayment = null,
  totalAmountPaid,
  financingType,
  showPaymentType,
}) => {
  const [showMonthlyPayment, setShowMonthlyPayment] = useState(true);

  useEffect(() => {
    setShowMonthlyPayment(!!showPaymentType);
  }, [showPaymentType]);

  const handleMonthlyPaymentClick = () => {
    setShowMonthlyPayment((prevState) => {
      mixpanel.track(`Rates Info ${financingType}`, {
        monthlyPayment,
        aprRate,
        financingType,
        showMonthlyPayment,
        path: window?.location?.pathname,
      });
      return !prevState;
    });
  };
  return (
    <div
      className="loan-term-info-section"
      style={{
        width: `${100 / len}%`,
      }}
    >
      {aprRate} <br />
      {monthlyPayment && (
        <Button
          sx={{ fontSize: { xs: '12px', md: '14px' } }}
          size="small"
          onClick={handleMonthlyPaymentClick}
        >
          {showMonthlyPayment ? monthlyPayment : totalAmountPaid}
        </Button>
      )}
    </div>
  );
};
